// @flow

import type { Dispatch as ReduxDispatch } from "redux";
import { logOut as bubaLogOut } from "buba-components/src/api/actions";
import { clearInquiryListParams } from "buba-components/src/utils/inquiryListParams";
import { CLEAR_USER_DATA, SAVE_USER_DATA, PASSWORD_REFRESHED } from "./actionTypes";
import { type StateUser, type ActionUser } from "./reducer";
import { getUserToken } from "./selectors";

type GetState = () => StateUser;
type ThunkAction = (dispatch: ReduxDispatch<ActionUser>, getState: GetState) => any;

export type ClearUserData = {
  type: typeof CLEAR_USER_DATA
};

export type PasswordRefreshedAction = {
  type: typeof PASSWORD_REFRESHED
};

export const saveUserData =
  (token: string, email: string, passwordExpired: boolean): ThunkAction =>
  dispatch =>
    dispatch({
      type: SAVE_USER_DATA,
      payload: {
        token,
        email,
        passwordExpired
      }
    });

export const clearUserData: ClearUserData = (): ThunkAction => (dispatch, getState) => {
  const token = getUserToken(getState());
  dispatch({ type: CLEAR_USER_DATA });
  clearInquiryListParams();
  return bubaLogOut(token).catch(() => {});
};

export const passwordRefreshed: PasswordRefreshedAction = (): ThunkAction => dispatch =>
  dispatch({ type: PASSWORD_REFRESHED });
